import type { RegularLangFnParameters } from '../../../util/localization';

// The web's language pack has no text for sending the code by SMS, because upstream's web client offers no
// such choice, and none for an expired code, which upstream shows as an unexpected error. The words are
// Android's, in both languages.
const STRINGS = {
  en: {
    sendCodeBySms: 'Send the code as an SMS',
    codeExpired: 'Code expired, please retry login.',
  },
  fa: {
    sendCodeBySms: 'ارسال کد به صورت پیامک',
    codeExpired: 'کد منقضی شده است، لطفاً از نو شروع کنید.',
  },
} as const;

const RE_CODE_EXPIRED = /\bPHONE_CODE_EXPIRED\b/;

export type JaryanAuthStringKey = keyof typeof STRINGS.en;

export function getJaryanAuthString(langCode: string | undefined, key: JaryanAuthStringKey) {
  const pack = langCode && langCode.toLowerCase().startsWith('fa') ? STRINGS.fa : STRINGS.en;
  return pack[key];
}

// An error the web has no words for reaches the page as `ErrorUnexpectedMessage` carrying the server's error
export function getJaryanAuthErrorText(langCode: string | undefined, errorKey: RegularLangFnParameters | undefined) {
  const error = errorKey?.key === 'ErrorUnexpectedMessage' ? errorKey.variables?.error : undefined;
  if (typeof error !== 'string' || !RE_CODE_EXPIRED.test(error)) return undefined;

  return getJaryanAuthString(langCode, 'codeExpired');
}
